import { HttpErrorResponse } from '@angular/common/http';

import { ReferralsSettings } from '@recruitee/http/types';
import { createSingleEntityStore, pipeState } from '@recruitee/ngrx';

const { actions, selectors, reducer, namespace } = createSingleEntityStore<ReferralsSettings>()(
  'ReferralsSettingsEntity',
  {
    customActions: adapter => ({
      toggleReferralProgram: (state, payload: { enabled: boolean }) => adapter.markAsPending(state),
      toggleReferralProgramSuccess: (state, payload: ReferralsSettings) =>
        pipeState(
          state,
          next => adapter.save(next, payload),
          next => adapter.markAsLoaded(next),
        ),
      toggleReferralProgramFailed: (state, payload: HttpErrorResponse) =>
        adapter.setError(state, payload),
    }),
  },
);

export {
  actions as ReferralsSettingsEntityActions,
  selectors as ReferralsSettingsEntitySelectors,
  reducer as ReferralsSettingsEntityReducer,
  namespace as ReferralsSettingsEntityNamespace,
};
